import './Nav.css';

const StudentNav = () => {
    return (
        <nav className='custom-nav'>
            <a
                target='_top'
                href='https://www.zorgnetwerktrento.be/vakantiewerk-jobstudent'
            >
                Aanvraag Vakantiewerk
            </a>

            <a target='_top' href='https://www.zorgnetwerktrento.be/aanvraag-stage'>
                Aanvraag Stage
            </a>
        </nav>
    );
};
export default StudentNav;
